var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Camada_1",
    "data-name": "Camada 1",
    x: 8,
    y: 24,
    width: 117,
    height: 85,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAABVCAYAAAB3qKuKAAABG0lEQVR4nO3bwWqDQABFUZX+/y9bCChqjWSXzuWcZQ20cBkCTt+8ruv04PEhXzW/++U/Nz8TcgzHTqfAy+XPF3RMp27HqIKObe+3RRW04dVxETRnvX6nEiBqkKhBogaJGiRqkKhBy9OLYYY0O6lBW1SnteHV8XhShR3b3u96n7o98D54HA4jAAAAAAAAwIfeLcldko/jzyX59T8fxBzP1myPa3TcYXQctY+OibEk77EkLxI1SNQgUYNEDRI1yOi4x+i4yOi4xeg4xug4xGEEAAAAAAAA+JDR8fiMjoOMjsOMjqOMjquMjnuMjotEDRI1SNQgUYNEDRI1yJK8ZzY6bjE6jrm9pZmEHdap2/U+dbp8wHvh/+v+AE7T9AvVIylrdjFFmwAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.8b77b040c2cf6f9edcec1d7f98c7c22d.svg";
export { ForwardRef as ReactComponent };